import Phaser from 'phaser';
import { BASE_H, BASE_W, COLORS } from '@/config/constants';
import { BootScene } from './scenes/BootScene';
import { PreloadScene } from './scenes/PreloadScene';
import { GameScene } from './scenes/GameScene';

export function createGame(parent: string): Phaser.Game {
  return new Phaser.Game({
    type: Phaser.AUTO,
    parent,
    backgroundColor: `#${COLORS.bg.toString(16).padStart(6, '0')}`,
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: BASE_W,
      height: BASE_H
    },
    physics: {
      default: 'arcade',
      arcade: { gravity: { x: 0, y: 0 }, debug: false }
    },
    input: {
      activePointers: 3,
      smoothFactor: 0
    },
    scene: [BootScene, PreloadScene, GameScene],
    fps: { target: 60, smoothStep: true },
    render: { antialias: true, pixelArt: false, roundPixels: false }
  });
}
